import api from "./base-api"

const tohUserApi = api.injectEndpoints({
    endpoints: (build) => ({
        searchTohUserIds: build.query({
            query: ({
                sTransactionId = ""
            }) => `v2/toh/users/search?sTransactionId=${sTransactionId}`
        }),
        getTohUserProfile: build.query({
            query: (userId) => `v2/toh/users/${userId}/profile`,
            providesTags: ["TohUserProfile"]
        }),
        avatarChangeBlockTOH: build.mutation({
            query: ({ userId, blocked }) => ({
                url: `v2/toh/users/${userId}/avatarChangeBlock?blocked=${blocked}`,
                method: "POST"
            }),
            invalidatesTags: ["TohUserProfile"]
        })
    })
})

export const {
    useSearchTohUserIdsQuery,
    useGetTohUserProfileQuery,
    useAvatarChangeBlockTOHMutation
} = tohUserApi
